import React from 'react';
export function Footer() {
  return <footer className="relative py-16 bg-bc-bg border-t border-hairline" data-id="element-66">
      <div className="container mx-auto px-6" data-id="element-67">
        <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-68">
          {/* Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/pVcT9SJxmKezCoeaC5imfz/Be_Clinical_logo_white_hex.png" alt="Be CLINICAL" className="mx-auto h-12 w-auto" data-id="element-69" />

          {/* Contact line */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-bc-bone-2 font-sans text-base" data-id="element-70">
            <a href="tel:925-215-1160" className="hover:text-bc-bone transition-colors bc-ease" data-id="element-71">
              925-215-1160
            </a>
            <span data-id="element-72">·</span>
            <a href="mailto:info@beclinical.com" className="hover:text-bc-bone transition-colors bc-ease" data-id="element-73">
              info@beclinical.com
            </a>
            <span data-id="element-74">·</span>
            <a href="https://beclinical.com" target="_blank" rel="noopener noreferrer" className="hover:text-bc-bone transition-colors bc-ease" data-id="element-75">
              beclinical.com
            </a>
          </div>

          {/* Address */}
          <p className="text-bc-bone-3 font-sans text-base" data-id="element-76">
            3130 Crow Canyon Place, San Ramon, CA 94583
          </p>

          {/* Links */}
          <div className="flex items-center justify-center gap-4 text-bc-bone-3 font-sans text-xs" data-id="element-77">
            <a href="#" className="hover:text-bc-bone transition-colors bc-ease" data-id="element-78">
              Privacy Policy
            </a>
            <span data-id="element-79">·</span>
            <a href="#" className="hover:text-bc-bone transition-colors bc-ease" data-id="element-80">
              Terms & Conditions
            </a>
          </div>

          {/* Credit */}
          <p className="text-bc-bone-3 font-sans text-xs pt-8" data-id="element-81">
            Managed by LetLois
          </p>
        </div>
      </div>
    </footer>;
}